/* unplugin-vue-components disabled */import { render } from "./ai-editor.vue?vue&type=template&id=51af155f&scoped=true"
import script from "./ai-editor.vue?vue&type=script&lang=js"
export * from "./ai-editor.vue?vue&type=script&lang=js"

import "./ai-editor.vue?vue&type=style&index=0&id=51af155f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51af155f"],['__file',"src/components/ai-chat-v2/ai-editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51af155f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51af155f', __exports__)) {
    api.reload('51af155f', __exports__)
  }
  
  module.hot.accept("./ai-editor.vue?vue&type=template&id=51af155f&scoped=true", () => {
    api.rerender('51af155f', render)
  })

}


export default __exports__